import React from "react";
import { Container, Image } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import first from "../../../../Asset/d2c/Decode-age-1.svg";
import second from "../../../../Asset/d2c/Alpino.svg";
import third from "../../../../Asset/d2c/Cow.svg";
import fourth from "../../../../Asset/d2c/bebe-burp.svg";
import fifth from "../../../../Asset/d2c/unnamed-2.png";

function Second() {
  const settings = {
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 100,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <section
        className="second-section trusted-company"
        style={{ backgroundColor: "var(--light-primary-bg)" }}
      >
        <Container>
          <div className="right-line">
            <h2 className="trusted-text">
              TRUSTED BY <span>LEADING D2C BRANDS </span>
            </h2>
          </div>
          <div className="slider-container first-carousal">
            <Slider {...settings} className="slider-main">
              <div>
                <Image src={second}></Image>
              </div>
              <div>
                <Image src={first}></Image>
              </div>
              <div>
                <Image src={third}></Image>
              </div>
              <div>
                <Image src={fourth}></Image>
              </div>
              <div>
                <Image src={fifth}></Image>
              </div>
            </Slider>
          </div>
        </Container>
      </section>
    </>
  );
}

export default Second;
